module.exports = __webpack_public_path__ + "img/img_banner_ipad.c2ad2ce6.jpg";